// extracted by mini-css-extract-plugin
module.exports = {"container":"Home_container__3myiG","header":"Home_header__wDYyq","footer":"Home_footer__3oZSW","main":"Home_main__2u8U0"};